module.exports = __webpack_public_path__ + "img/manulife-logo-white-fr.8c0816f5.png";